import api from "@/services/support/api";
import {IInstitutionList} from "@/services/contracts/IInstitutionList";

class TeacherInstitutionService {

    find(competitionId: number) {
        return api.get<IInstitutionList>(`teacher-institutions/competition/${competitionId}`);
    }
}

export default new TeacherInstitutionService();
